import { Component, Input } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { JsonCase } from 'src/model/dto';

@Component({
  selector: 'tudi-case-big-photo',
  templateUrl: './case-big-photo.component.html',
  styleUrls: ['./case-big-photo.component.scss']
})
export class CaseBigPhotoComponent {
  @Input() case: JsonCase;

  constructor(
    private appService: AppService,
  ) { }

  isShow = false;

  show(): void {
    this.isShow = true;
  }

  closeBigPhoto(): void {
    this.isShow = false;
  }
}
